import { Injectable, inject } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, Dictionary } from '@softline/core';
import { SOFTLINE_API_GARAGE_ORDER_NOTES } from '../garage.api';
import { OrderNote } from '../models/order-note';

@Injectable()
export class OrderNotesRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown>
  ): ApiResourceLocation {
    return pathParams ? { path, pathParams } : { path };
  }

  retrieve(id: number): Promise<OrderNote[]> {
    return this.#dataAccess.get(
      this.createLocation(SOFTLINE_API_GARAGE_ORDER_NOTES, { id })
    );
  }
  create(id: number, note: OrderNote): Promise<OrderNote> {
    return this.#dataAccess.create(
      this.createLocation(SOFTLINE_API_GARAGE_ORDER_NOTES, { id }),
      note
    );
  }
}
